import { Tone } from './ComposerParts';

/**
 * A risk word ("High", "medium risk", "Clear") as the verdict tone the
 * screening boxes color by. Anything else, including Unknown and N/A, is
 * 'none': grey, never green.
 */
export const riskToneOf = (value: unknown): Tone => {
  const risk = String(value || '').toLowerCase();
  if (risk.includes('high')) return 'high';
  if (risk.includes('medium')) return 'medium';
  if (risk.includes('low') || risk.includes('clear')) return 'low';
  return 'none';
};
